import EmailType from '../Models/EmailType';
import DataGridRequest from './DataGridRequest';
export class EmailsRequest extends DataGridRequest<EmailType> {
    Url = 'emails/home/api';
}
